export default __webpack_public_path__ + "static/media/insurance.96b63194.svg";